import { Controller } from "stimulus";
import Sortable from "sortablejs";
import enableElement from "../functions/enableElement";
import disableElement from "../functions/disableElement";
import dispatchCustomEvent from "../functions/dispatchCustomEvent";

export default class extends Controller {
  static get targets() {
    return [
      "sortedList",
      "unsortedList",
      "sortPriorityField",
      "sortingChanged",
      "submitButton",
    ];
  }

  connect() {
    this._initializeSortedList();
    this._initializeUnsortedList();
    this._enableSortedFields();
    this._disableUnsortedFields();
    this._showPlaceholderIfEmpty();
    this._setSortedInputs();
    this._setInitialValues();
    this._setSortingChangedValue();

    disableElement(this.submitButtonTarget);
  }

  onStart() {
    disableElement(this.submitButtonTarget);
  }

  onEnd() {
    this._enableSortedFields();
    this._disableUnsortedFields();
    this._showPlaceholderIfEmpty();
    this._setSortedInputs();
    this._setSortingChangedValue();

    dispatchCustomEvent(this.sortingChangedTarget, "change");
  }

  _setSortedInputs() {
    var i = 0;
    this.sortPriorityFieldTargets.forEach((input) => {
      if (this.sortedListTarget.contains(input)) {
        input.value = i;
        i++;
      }
    });
  }

  _enableSortedFields() {
    this.sortedListTarget.querySelectorAll("input").forEach((input) => {
      enableElement(input);
    });
  }

  _disableUnsortedFields() {
    if (this.hasUnsortedListTarget) {
      this.unsortedListTarget.querySelectorAll("input").forEach((input) => {
        disableElement(input);
      });
    }
  }

  _initializeSortedList() {
    new Sortable(this.sortedListTarget, {
      group: this.element.id,
      forceFallback: this._forceFallback,
      animation: this._delay,
      onStart: this.onStart.bind(this),
      onEnd: this.onEnd.bind(this),
    });
  }

  _initializeUnsortedList() {
    if (this.hasUnsortedListTarget) {
      new Sortable(this.unsortedListTarget, {
        group: this.element.id,
        forceFallback: this._forceFallback,
        animation: this._delay,
        sort: false,
        onStart: this.onStart.bind(this),
        onEnd: this.onEnd.bind(this),
      });
    }
  }

  _showPlaceholderIfEmpty() {
    if (this._isEmpty(this.sortedListTarget)) {
      this.sortedListTarget.classList.add("empty");
    } else {
      this.sortedListTarget.classList.remove("empty");
    }

    if (this.hasUnsortedListTarget) {
      if (this._isEmpty(this.unsortedListTarget)) {
        this.unsortedListTarget.classList.add("empty");
      } else {
        this.unsortedListTarget.classList.remove("empty");
      }
    }
  }

  get _isTestEnvironment() {
    return document.head.querySelector("meta[name=hanami_env]").content ===
      "test";
  }

  get _delay() {
    return this._isTestEnvironment ? 0 : 150;
  }
  get _forceFallback() {
    return !!this._isTestEnvironment;
  }

  _isEmpty(list) {
    return list.querySelectorAll("input").length === 0;
  }

  _setInitialValues() {
    this.initialSortedList = [
      ...this.sortedListTarget.querySelectorAll("input"),
    ];
  }

  _sortingChanged() {
    this.currentSortedList = [
      ...this.sortedListTarget.querySelectorAll("input"),
    ];

    return (
      this.initialSortedList.length !== this.currentSortedList.length ||
      this.initialSortedList.some((v, i) => v !== this.currentSortedList[i])
    );
  }

  _setSortingChangedValue() {
    if (this._sortingChanged()) {
      this.sortingChangedTarget.value = "true";
    } else {
      this.sortingChangedTarget.value = "false";
    }
  }
}
